// @flow
import styled from 'styled-components';
import { below } from "../../assets/css/media";

export const ModalBody = styled.div`
	max-height: 70vh;
	overflow: auto;
	${below.desktop`
		height: 500px;
		max-height: 70vh;
	`}

	${below.tablet`
		height: 70vh;
	`}
`;

export default ModalBody;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalBody.js